import type { ColumnDefinition } from "@frui.ts/dataviews";
import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import ListView from "../../common/list";
import ExemptionReasonsViewModel from "viewModels/timeCharges/exemptionReasons/exemptionReasonsViewModel";
import type ExemptionReasonResponse from "entities/exemptionReasonResponse";

export const ExemptionReasonsView: ViewComponent<ExemptionReasonsViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<ExemptionReasonResponse>[] = [
    {
      title: vm.translateAttribute("exemptionReason"),
      property: "exemptionReason",
    },
    {
      title: vm.translateAttribute("languageCode"),
      property: "languageCode",
    },
    {
      title: vm.translateAttribute("description"),
      cellClassName: "text-wrap",
      property: "description",
      valueFormatter: props => {
        return <span dangerouslySetInnerHTML={{ __html: props.value }}></span>;
      },
    },
  ];

  return <ListView vm={vm} columns={columns} />;
});

registerView(ExemptionReasonsView, ExemptionReasonsViewModel);
